<!-- /src/components/common/Header/_HeaderLogo.vue -->
<template>
<svg version="1.2" baseProfile="tiny" id="Group_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 x="0px" y="0px" viewBox="0 0 363.4 62.4" overflow="visible" xml:space="preserve">
<g id="CARR_Logo_Blue" :class="colorClassBlue">
	<path d="M44.6,57.8c5.2-1.5,8.3-6.9,9.2-11.9c0.2-1,0.4-1.3,0.9-1.3s0.6,0.6,0.6,1.3c-0.4,3.9-1.1,7.8-2,11.7
		c-0.5,1.8-0.6,2.3-2.4,2.7c-3,0.6-11,1.8-13,2C21,63,5.2,55.7,0.9,36.8c-0.3-1.3-0.5-2.7-0.6-4.1C-0.4,22.6,4.5,13.8,12,8
		c7.1-5.3,15.7-8.1,24.6-7.8c6,0.2,12,1.6,17.9,2.4c1.3,0.2,1,2.7,1,3.5c-0.2,4-0.6,8-0.9,12c-0.1,1.3-0.3,1.9-0.8,1.9
		S53,19.4,53,18.1c-0.1-4.8-2.7-9.3-6.8-11.8c-8.8-5.4-20.7-3-28.2,3.7C6.4,20.7,5.6,39,16.4,50.7c1.5,1.6,3.1,3,4.9,4.2
		C28.4,59.7,36.6,60.2,44.6,57.8"/>
	<path d="M108.7,59.5c-1.3-0.9-1.7-1.7-4.8-9.1C99,38.7,86.3,6.7,85,3.5c-1-2.7-0.9-3-1.3-3s-0.9,0.5-2,3.2
		L63.1,52.5c-1.6,3.9-4.6,6.9-7.2,7.2s-2.5,0.5-2.5,0.9s1,0.7,2,0.7h14.2c0.7,0,1.3-0.2,1.3-0.7s-0.3-0.7-1.1-0.7h-0.6
		c-2.1,0-2.6-0.8-2.6-2.4V57c0.5-2.1,1.2-4.2,2.1-6.2l4.1-11.7c0.1-0.4,0.5-0.7,0.9-0.7h17.1c0.3,0,0.6,0.2,0.8,0.5l6.9,18.8
		c0.6,1.3,0,1.9-0.4,2H98c-0.4,0.1-0.8,0.1-1.2,0.1h-0.8c-0.8,0-1.1,0.3-1.1,0.7s0.4,0.6,1.4,0.7s7.5,0.1,13.5,0
		c1,0,1.8-0.1,1.8-0.6C111.5,59.7,109.4,59.8,108.7,59.5 M89.8,35.1h-15c-0.2,0-0.4-0.2-0.2-0.6l7-20.7c0.5-1.3,0.6-1.3,1,0L90,34.6
		C90.1,34.9,90.1,35.2,89.8,35.1"/>
	<path d="M170.7,24.1c0-12.3,0-14.6-0.2-17.1s-1.9-3.9-4.8-4.5c-0.7-0.1-1.5-0.2-2.2-0.2c-0.7,0-1-0.2-1-0.6
		s0.3-0.6,1.1-0.6c4,0,10.8,0.3,10.9,0.3c0.9,0,7.2-0.3,9.8-0.3c5.2,0,10.9,0.5,15.4,3.5c3.6,2.7,5.6,6.9,5.6,11.4
		c0,5.1-3,12.2-10.4,18.2c4.1,7.2,9,13.8,14.6,19.8c4.5,4.5,5.8,5.9,8.2,5.9c0.8,0,1,0.3,1,0.7s-0.4,0.7-1.7,0.7h-1.4
		c-4.4,0-5.9-0.3-8-1.1c-3.9-1.7-6.7-5.9-11.6-12.1c-3.6-4.5-6.9-9.5-8.5-11.5c-0.3-0.3-0.7-0.5-1.1-0.5l-8.1-0.1
		c-0.4,0-0.5,0.1-0.5,0.5v1.3c-0.1,5.9,0,11.8,0.5,17.7c0.3,2.2,0.6,4.1,3.6,4.5c0.9,0.1,2,0.2,2.7,0.2s1.2,0.3,1.2,0.6
		s-0.4,0.7-1.3,0.7h-17c-0.9,0-1.4-0.2-1.3-0.7c0-0.3,0.5-0.5,1.2-0.6c1.9-0.3,2.5-1.4,2.8-3.7c0.5-3.4,0.4-11,0.4-18L170.7,24.1z
		 M177.9,30.8c-0.1,0.4,0.1,0.9,0.5,1.1c2.7,0.9,5.5,1.3,8.3,1.2c2.2,0.2,4.4-0.3,6.3-1.4c2.8-1.8,4.7-5.9,4.7-11.9
		c0-10.2-5.4-15.9-13.8-15.9c-1.8,0-3.6,0.1-5.4,0.5c-0.4,0.1-0.6,0.5-0.6,0.8L177.9,30.8z"/>
	<path d="M117,24.1c0-12.3,0-14.6-0.2-17.1s-1.9-3.9-4.8-4.5c-0.7-0.1-1.5-0.2-2.2-0.2c-0.7,0-1-0.2-1-0.6
		s0.3-0.6,1.1-0.6c4,0,10.7,0.3,10.9,0.3c0.8,0,7.2-0.3,9.8-0.3c5.2,0,11,0.5,15.3,3.5c3.6,2.7,5.7,6.9,5.6,11.4
		c0,5.1-3,12.2-10.4,18.2c4.1,7.2,9,13.8,14.7,19.8c4.4,4.5,5.8,5.9,8.1,5.9c0.8,0,1,0.3,1,0.7s-0.4,0.7-1.7,0.7h-1.4
		c-4.4,0-5.9-0.3-8-1.1c-4-1.7-6.7-5.9-11.6-12.2c-3.6-4.5-6.9-9.5-8.5-11.5c-0.3-0.4-0.7-0.6-1.1-0.6l-8.1-0.1
		c-0.4,0-0.5,0.1-0.5,0.5v1.3c-0.1,5.9,0,11.8,0.5,17.7c0.3,2.2,0.6,4.1,3.7,4.5c0.9,0.1,1.9,0.2,2.7,0.2s1.2,0.3,1.2,0.6
		s-0.4,0.7-1.3,0.7h-17c-0.9,0-1.4-0.2-1.3-0.7c0-0.3,0.5-0.5,1.2-0.6c1.9-0.3,2.5-1.4,2.8-3.7c0.5-3.4,0.4-11,0.4-18L117,24.1z
		 M124.2,30.8c-0.1,0.4,0.1,0.9,0.5,1.1c2.7,0.9,5.5,1.3,8.3,1.2c2.2,0.2,4.4-0.3,6.3-1.4c2.8-1.8,4.7-5.9,4.7-11.9
		C143.9,9.7,138.5,4,130.2,4c-1.8,0-3.6,0.1-5.4,0.5c-0.4,0.1-0.6,0.5-0.6,0.8L124.2,30.8z"/>
</g>
<rect :class="colorClassOrange" x="238.3" width="1.9" height="62.4"/>
<g :class="colorClassOrange">
	<path d="M283.3,6h5.4l23.4,51.8h-6.2l-6-13.6h-28l-6.1,13.6h-6L283.3,6z M297.6,39l-11.7-26.2L274.2,39H297.6z"/>
	<path d="M317,32.3v-0.1c0-14.5,10.9-26.6,26-26.6c9.3,0,14.9,3.3,20.1,8.2l-4,4.3c-4.3-4.1-9.2-7-16.2-7
		c-11.4,0-19.9,9.2-19.9,21.1v0.2c0,11.9,8.6,21.2,19.9,21.2c7,0,11.7-2.7,16.6-7.4l3.8,3.7c-5.4,5.4-11.2,9-20.6,9
		C328,58.7,317,47,317,32.3z"/>
</g>
</svg>
</template>

<script>
export default {
	computed: {
		colorClassBlue() {
			return this.$store.getters['getHeaderRevState'] ? 'color-white' : 'color-blue'
		},
		colorClassOrange() {
			return this.$store.getters['getHeaderRevState'] ? 'color-orange' : 'color-white'
		},
	},
}
</script>

<style scoped>

g {
	transition: fill .2s ease;
}

.color-white {
  fill: #fff;
}

.color-orange {
  fill: var(--brandAccent);
}

.color-blue {
  fill: var(--brandPrimary);
}
</style>
